
import React, { useEffect, useState } from "react";
import { isNumber } from "../../Utils/Common";
import PropagateLoader from "react-spinners/PropagateLoader";
import { POST_PAYOUT_ADD_CUSTOMER_DETAIL, MOBILE_SEND_OTP, MOBILE_SEND_VERFIY } from '../../Utils/appConstants';
import { useHistory } from "react-router-dom";
import { postRequest } from '../../Utils/AppApi';
import { ToastContainer, toast } from 'react-toastify';
import moment from "moment";
import { Modal } from 'antd';
// import axios from 'axios';
// import xmlJs from 'xml-js';
// import BioDevice from '../aeps2/bioDevice';
// import DmtAadharVerify from '../dmtAadharVerify';
// import { encryptAadhar } from "../../Utils/function";

function AddCustomer(props) {
    const history = useHistory();
    const customerMobile = props && props.mobile;
    const [isLoading, setLoading] = useState(false);
    const [isOtpModal, setOtpModal] = useState(false);
    const [otpCode, setOtpCode] = useState(null)
    // const [referenceKey, setReferenceKey] = useState(null);
    const [getDataError, setDataError] = useState({});
    const [getDataField, setDataField] = useState({});
    const [otpSent, setOtpSent] = useState(false);
    const [resendTime, setResendTime] = useState(0);

    // const [isConsent, setConsent] = useState("Y");
    // const [isBioAuthModel, setBioAuthModel] = useState(false);
    // const [instantTransferModal, setInstantTransferModal] = useState(false);
    // const [isAadharModal, setAadharModal] = useState(false);
    // const [aadharNumber, setAadharNumber] = useState("");

    // const [isErrorAuth, setErrorAuth] = useState(false);
    // const [errorMessage, setErrorMessage] = useState(null);
    // const [fingerprintXmlData, setFingerprintXmlData] = useState(null)
    // const [deviceConfig, setDeviceConfig] = useState({});
    // const [latitude, setLatitude] = useState("");
    // const [longitude, setLongitude] = useState("");
    // const [biometricData, setBiometricData] = useState(null);

    const onChangeOtpValue = (value) => {
        setOtpCode(value);
    }

    const FormValidate = () => {
        let formValid = true;
        let formObject = {};
        setDataError({})
        if (getDataField && getDataField.length === 0) {
            formValid = false;
        }
        let array = ["customerName", "customerMobile"];
        // let array = ["customerName", "customerMobile", "pincode", "aadharNumber"];

        array.forEach(element => {
            if (getDataField[element] === "" || typeof getDataField[element] === "undefined") {
                formObject[element] = true;
                formValid = false;
            }
        });

        setDataError(formObject);
        return formValid;
    }

    const onChangeValue = (event) => {
        const { name, value } = event.target;
        setDataField({ ...getDataField, [name]: value });
    }

    const handleVerifyMobileNumber = () => {
        if (customerMobile && FormValidate() === true) {
            setLoading(true);
            const payload = { mobile: customerMobile, isremittance: true };
            postRequest(MOBILE_SEND_OTP, payload, history).then((response) => {
                if (response.success === true) {
                    toast.success(response.message);
                    setOtpModal(true)
                } else {
                    toast.error(response.message);
                }
                setLoading(false);
            }).catch(function (error) {
                // console.log(error)
                setLoading(false);
            })
        }
    }

    const handleVerifyOtpMobileNumber = () => {
        setLoading(true);
        const payload = {
            mobile: customerMobile,
            otp: otpCode
        }
        postRequest(MOBILE_SEND_VERFIY, payload, history).then((response) => {
            if (response.success === true) {
                toast.success(response.message);
                setOtpModal(false)
                handleSubmit();
            } else {
                toast.error(response.message);
            }
            setLoading(false);
        }).catch(function (error) {
            // console.log(error)
            setLoading(false);
        })
    }

    const handleSubmit = () => {
        // console.log("1========== submit")
        // console.log("1========== FormValidate()", FormValidate())
        // console.log("1========== FormValidate()", getDataField)
        if (FormValidate() === true) {
            setLoading(true)
            // console.log("========== submit")
            const payload = {
                customerMobile: customerMobile,
                apiName: "CASHFREE",
                customerName: getDataField.customerName,
                customerDob: getDataField.dateOfBirth
            };
            // setAadharNumber(getDataField.aadharNumber && encryptAadhar(getDataField.aadharNumber));
            postRequest(`${POST_PAYOUT_ADD_CUSTOMER_DETAIL}`, payload, history).then((response) => {
                if (response.success === true) {
                    props.findCustomerInfo();
                    // setReferenceKey(response.data.referenceKey);
                    console.log("response========== ", response)
                    toast.success(response.message);
                } else {
                    toast.error(response.message);
                }
                handleResendOtp();
                setLoading(false)
            }).catch(function (error) {
                // console.log(error)
                setLoading(false)
            })
        }
    }

    const handleResendOtp = () => {
        // Simulate sending OTP
        console.log('OTP sent!');
        setOtpSent(true);

        // Set a timer for 2 minutes (in seconds)
        const timerDuration = 2 * 60;
        setResendTime(timerDuration);

        const resendTimer = setInterval(() => {
            setResendTime(prevTime => (prevTime > 0 ? prevTime - 1 : 0));
        }, 1000); // Update the timer every second

        // Additional logic for resending OTP can be added here
        // Cleanup the timer on component unmount or if you navigate away
        return () => {
            clearInterval(resendTimer);
        };
    };

    // const handleCloseModal = () => {
    //     setBioAuthModel(false)
    // }

    // const onChangeChackBox = (e) => {
    //     if (e.target.checked === true) {
    //         setConsent('Y')
    //     } else {
    //         setConsent('N')
    //     }
    // };

    useEffect(() => {
        // navigator.geolocation.getCurrentPosition((data) => {
        //     setLatitude(data.coords.latitude);
        //     setLongitude(data.coords.longitude);
        // });
        // console.log("latitude ========== ", latitude)
        // console.log("longitude ========== ", longitude)
        let lastDate = moment().subtract(19, 'years');
        let dateValue = moment(lastDate).format('YYYY-MM-DD');
        setDataField({ ...getDataField, customerMobile: customerMobile, dateOfBirth: dateValue });
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const formatTime = seconds => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    if (isLoading) {
        return <div className="content text-center" style={{ margin: "250px 0" }}>
            <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
        </div>
    }
    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="card m-0 ">
                    <div className="card-body m-0 py-0">
                        <div className="row gx-3 mb-3">
                            <div className="col-md-6">
                                <label className="small mb-1" >Name</label>
                                <input className="form-control" type="text" placeholder="Enter Full Name" name="customerName" value={getDataField.customerName} onChange={(e) => onChangeValue(e)} maxLength={30} />
                                {getDataError && getDataError.customerName && <span className="error text-danger">The field is required</span>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xl-12">
                <button className="btn btn-primary float-right" onClick={() => handleVerifyMobileNumber()} type="button">Add Customer</button>
                <ToastContainer position="top-center" autoClose={5000} limit={2} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />
            </div>
            {isOtpModal && <Modal title={"Customer Verification OTP"} width={600} open={isOtpModal} onOk={() => handleVerifyOtpMobileNumber()} onCancel={() => setOtpModal(false)} okText={"Submit"} >
                <div className="form-group">
                    <label>OTP Code</label>
                    <div className="input-group">
                        <div className="custom-file">
                            <input type="text" className="form-control" name="otpCode" placeholder="OTP Code" onChange={(e) => onChangeOtpValue(e.target.value)} autoComplete="off" value={otpCode} maxLength={6} onKeyDown={isNumber} />
                        </div>
                    </div>
                    <div className="text-right">
                        {otpSent && <p>Resend in: {formatTime(resendTime)}</p>}
                        <button type='button' onClick={() => handleVerifyMobileNumber()} className='btn btn-sm btn-warning mt-2 text-right' disabled={otpSent}>Resend OTP</button>
                    </div>
                </div>
            </Modal>}
        </div>
    )
}

export default AddCustomer;